import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import PageLayout from 'layouts/PageLayout';
import Sidebar from 'scenes/Sidebar';
import RelatedJobs from 'scenes/Sidebar/components/RelatedJobs';
import CtaBanner from 'scenes/Sidebar/components/CtaBanner';
import ReviewCard from './components/ReviewCard';
import ReviewContent from './components/ReviewContent';
import ReviewMeta from './components/ReviewMeta';
import ReviewHeader from './components/ReviewHeader';
import PanelContainer from 'components/PanelContainer';
import FiltersContentLoader from 'components/FiltersContentLoader';
import ReviewContentLoader from 'components/ReviewContentLoader';
import { CSSTransition } from 'react-transition-group';
import { ANIMATION_TIMEOUT_APPEAR } from 'constants/animation.js';

import { REVIEW_TYPES } from 'constants/review-types';
import { ROUTE } from 'constants/route';
import { ENDPOINT } from 'constants/endpoints';
import { useReviewAction } from 'hooks/useReviewAction';
import { useApi } from 'hooks/useApi';

import ctaBackground from 'assets/images/cta_back_signup.jpg';
import './styles.css';

const Review = props => {
  const {
    match: {
      params: { firmname, type, reviewName },
    },
    user,
    history,
    globalOptions,
  } = props;

  const urlFirm = `/firm/${firmname}`;

  const api = useApi();

  const [isFetching, setFetching] = useState();
  const [review, setReview] = useState();

  const { rate: rateReview, isAllowedRate } = useReviewAction(
    user,
    globalOptions
  );

  useEffect(() => {
    setFetching(true);
    api.get(
      ENDPOINT.ENTITY.REVIEW,
      { type, name: reviewName },
      {
        handleError: () => history.replace(ROUTE.ERROR_404),
        handleSuccess: review => {
          setFetching(false);
          setReview(review);
        },
      }
    );
  }, [firmname, type, reviewName]);

  const gotoFormReview = () => {
    history.push(
      `${urlFirm}/add-${
        type === REVIEW_TYPES.OVERVIEW ? REVIEW_TYPES.COMPANY : type
      }-review`
    );
  };

  const gotoReviewsTab = () => {
    if (review.firm.tabs.review) {
      history.push(`${urlFirm}/reviews`);
    }
  };

  const handleBeforeRatingUpdate = () => {
    return isAllowedRate(review);
  };

  const handleRatingUpdate = value => {
    rateReview(review, value).then(data =>
      data ? setReview({ ...review, ...data }) : null
    );
  };

  return (
    <PageLayout
      pageClass="review-page"
      headerContent={
        !user.isLoggedIn && (
          <CSSTransition
            in={true}
            appear={true}
            timeout={ANIMATION_TIMEOUT_APPEAR}
            classNames="fade"
          >
            <ReviewHeader
              pageUrl={urlFirm}
              review={review}
              actions={{
                onLinkClickHandler: gotoReviewsTab,
                onButtonClickHandler: gotoFormReview,
              }}
              onLinkClickHandler={gotoReviewsTab}
              onButtonClickHandler={gotoFormReview}
            />
          </CSSTransition>
        )
      }
      mainContent={
        <CSSTransition
          in={true}
          appear={true}
          timeout={ANIMATION_TIMEOUT_APPEAR}
          classNames="fade"
        >
          <>
            {isFetching && <ReviewContentLoader />}
            {review && (
              <>
                <CSSTransition
                  in={true}
                  appear={true}
                  timeout={ANIMATION_TIMEOUT_APPEAR}
                  classNames="fade"
                >
                  <PanelContainer>
                    <Helmet>
                      <title>{review.position}</title>
                    </Helmet>
                    <ReviewCard
                      review={review}
                      isLoggedIn={user.isLoggedIn}
                      actions={{
                        onRatingUpdateHandler: handleRatingUpdate,
                        onBeforeRatingUpdateHandler: handleBeforeRatingUpdate,
                      }}
                    />
                  </PanelContainer>
                </CSSTransition>
                {review.describe && (
                  <CSSTransition
                    in={true}
                    appear={true}
                    timeout={ANIMATION_TIMEOUT_APPEAR}
                    classNames="fade"
                  >
                    <PanelContainer>
                      <ReviewContent
                        companyReviewCompensation={review.compensation}
                        companyReviewInfo={review.describe}
                      />
                    </PanelContainer>
                  </CSSTransition>
                )}
                <CSSTransition
                  in={true}
                  appear={true}
                  timeout={ANIMATION_TIMEOUT_APPEAR}
                  classNames="fade"
                >
                  <PanelContainer>
                    <ReviewMeta companyReviewMeta={review.text} />
                  </PanelContainer>
                </CSSTransition>
              </>
            )}
          </>
        </CSSTransition>
      }
      sidebarContent={
        <CSSTransition
          in={isFetching}
          appear={true}
          timeout={ANIMATION_TIMEOUT_APPEAR}
          classNames="fade"
        >
          {!isFetching ? (
            <Sidebar>
              {!user.isLoggedIn && (
                <CtaBanner
                  blockHeight="150"
                  blockBg={ctaBackground}
                  blockText="Recruit Talent Through GoBuyside"
                  blockFontSize="20"
                />
              )}
              <RelatedJobs user={user} history={history} />
            </Sidebar>
          ) : (
            <FiltersContentLoader />
          )}
        </CSSTransition>
      }
    />
  );
};

export default withRouter(Review);
